module.exports = __webpack_public_path__ + "img/13_sp.0c5cb9ae.gif";